import axios from '@axios'

const CREATIVE_SERVICE_URL = process.env.VUE_APP_CREATIVE_SERVICE_URL

export default {
  getListCampaign(params) {
    return axios.get('/api/ads-managements/campaign', { params })
  },

  getListAdGroup(params) {
    return axios.get('/api/ads-managements/adgroup', { params })
  },

  getListAdGroupSpp(params) {
    return axios.get('/api/ads-managements/smart-plus/adgroup', { params })
  },

  getListAdCampaignSpp(params) {
    return axios.get('/api/ads-managements/smart-plus/ad', { params })
  },

  getListAdCampaignSp(params) {
    return axios.get('/api/ads-managements/spc/ad', { params })
  },

  getListAdCampaignManual(params) {
    return axios.get('/api/ads-managements/ad', { params })
  },

  getListIdentity(params) {
    return axios.get('/api/ads-managements/identity', { params })
  },

  getListVideoTikTok(params) {
    return axios.get('/api/ads-managements/identity/video', { params })
  },

  getListVideoCreative(params) {
    return axios.get('/api/ads-managements/file/video', { params })
  },

  getThumbnailVideoCreative(params) {
    return axios.get('/api/ads-managements/file/video/suggest-cover', { params })
  },

  getListVideoLibrary(params) {
    return axios.get(`${CREATIVE_SERVICE_URL}/api/creative/video/list`, { params })
  },

  syncVideoToAdAccount(params) {
    return axios.post(`${CREATIVE_SERVICE_URL}/api/creative/video/ads/sync`, params)
  },

  duplicateCampaigns(params) {
    return axios.post(`/api/ads-managements/smart-plus/campaign/duplicate?advertiserId=${params.advertiserId}`, params)
  },

  updateStatusCampaign(params) {
    return axios.put('/api/ads-managements/smart-plus/campaign/status', params)
  },

  updateStatusAdGroup(params) {
    return axios.put('/api/ads-managements/smart-plus/adgroup/status', params)
  },

  updateStatusAd(params) {
    return axios.put('/api/ads-managements/smart-plus/ad/status', params)
  },

  getListLocation(params) {
    return axios.get('/api/ads-managements/locations', { params })
  },
}
